import styled from 'styled-components';
import type { VimeoWidget } from '../../types';
import { EmptyWidget } from './EmptyWidget';
import { useGuideStore } from '../../stores/guideStore';
import { useActiveWidget } from '../../queries/guides';
import { useTranslate } from '@bynder/localization';
import { IconVimeo } from '@bynder/icons';
import { toPx, useWidgetStyleProperty } from '../guides/Inspector/helpers';
import { CSS_PROPERTIES } from '../guides/Inspector/constants';

const VimeoWidget = ({ vimeoWidget }: { vimeoWidget: VimeoWidget }) => {
  const isEmpty = !vimeoWidget.sourceId;
  const isEditMode = useGuideStore(s => s.isEditMode);
  const activeWidget = useActiveWidget();
  const isActiveWidget = vimeoWidget.id === activeWidget?.id;
  const { translate } = useTranslate();
  const { value: borderRadius } = useWidgetStyleProperty(
    vimeoWidget?.style?.stylesheet,
    'widgets.media.borderRadius',
    CSS_PROPERTIES.BORDER_RADIUS,
  );

  if (isEmpty) {
    if (isEditMode) {
      return (
        <EmptyWidget
          text={translate('WIDGETS_CONSTANTS.EMPTY_WIDGETS.VIMEO')}
          icon={<IconVimeo />}
        />
      );
    }
    return null;
  }

  return (
    <>
      {isEditMode && !isActiveWidget && <SelectionOverlay />}
      <EmbedContainer $borderRadius={borderRadius}>
        <Iframe
          title="vimeo-player"
          src={`https://player.vimeo.com/video/${vimeoWidget.sourceId}?&autoplay=${vimeoWidget.settings.autoplay ? '1&mute=1' : '0'}&loop=${vimeoWidget.settings.loop ? '1' : '0'}&${vimeoWidget.settings.detailsShown ? 'title=1&byline=1&portrait=1' : 'title=0&byline=0&portrait=0'}`}
          width="640"
          height="360"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
        />
      </EmbedContainer>
    </>
  );
};

const SelectionOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const EmbedContainer = styled.div<{ $borderRadius: string }>`
  border-radius: ${({ $borderRadius }) => toPx($borderRadius)};
  overflow: hidden;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
`;

const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`;

export default VimeoWidget;
